import { render, staticRenderFns } from "./Air.vue?vue&type=template&id=5d509904&scoped=true&"
import script from "./Air.vue?vue&type=script&lang=js&"
export * from "./Air.vue?vue&type=script&lang=js&"
import style0 from "./Air.vue?vue&type=style&index=0&id=5d509904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d509904",
  null
  
)

export default component.exports